export const environment = {
  production: true,
  env: "prod",
  apiHost: "https://api.qa-beta.zceppa.com/",
  adminApiHost: "https://admin-api.qa-beta.zceppa.com/",
  widgetDomain: "https://widget.zceppa.com/",
  spritePath: "assets/sprites/sprite.svg",
  fbAppId: "2262024527378539",
  pusher: {
    key: "010d0565b3d2f39e34df",
    cluster: "ap2",
  }
};
